import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Box, TextField, Typography } from '@mui/material'
import { updateDistrict } from 'shared/api/mutations'

interface DistrictNotesProps {
  districtId: string
  initialNotes: string
}

export function DistrictNotes({
  districtId,
  initialNotes,
}: DistrictNotesProps) {
  const [notes, setNotes] = useState(initialNotes)
  const [saved, setSaved] = useState(false)
  const [error, setError] = useState(false)
  const lastSavedRef = useRef(initialNotes)

  useEffect(() => {
    setNotes(initialNotes)
    lastSavedRef.current = initialNotes
  }, [initialNotes])

  const saveNotes = useCallback(async () => {
    if (notes === lastSavedRef.current) return
    try {
      await updateDistrict({ id: Number(districtId), notes })
      lastSavedRef.current = notes
      setError(false)
      setSaved(true)
      setTimeout(() => setSaved(false), 2000)
    } catch {
      setError(true)
      setTimeout(() => setError(false), 3000)
    }
  }, [districtId, notes])

  return (
    <Box sx={{ my: 2 }}>
      <Typography variant="subtitle2" gutterBottom>
        District Notes
      </Typography>
      <TextField
        multiline
        minRows={3}
        maxRows={10}
        fullWidth
        placeholder="Add notes about this district (sync issues, contacts, special configs...)"
        value={notes}
        onChange={(e) => setNotes(e.target.value)}
        onBlur={saveNotes}
        size="small"
        variant="outlined"
      />
      {saved && (
        <Typography variant="caption" color="success.main">
          Notes saved
        </Typography>
      )}
      {error && (
        <Typography variant="caption" color="error.main">
          Error saving notes
        </Typography>
      )}
    </Box>
  )
}
